import { createContext } from 'react'

const AppContext = createContext({
    isLoggedIn: false,
    isLoading: false,
    user: {},
    client: {},
    sites: [],
    activeSite: {},
    type: '',
    loginHandler: (type, email, password) => {},
    logoutHandler: () => {},
    loadingHandler: () => {},
})

export default AppContext